module.exports = "<h2 id=\"news\">NEWS</h2>\n<br>\n<br>\n<br>\n";


//////////////////
// WEBPACK FOOTER
// ./src/assets/copy/news_de.md
// module id = 9zC8
// module chunks = 0